const category ='Profile box';

export const SegmentProfileBoxEvent = {
    OPEN: { category, event: 'Profile box opened' },
    PRICING_ROW: { category, event: 'Pricing opened from profile box' },
    SWITCH_ACCOUNT: { category, event: 'Switch account clicked from profile box' },
    LOGOUT: { category, event: 'Logout clicked from logout clicked' },
}
